@if (hasPermission && documents$ && documents$ | async; as docs) {
  @if (docs.cmisEntries.length > 0) {
    <ng-container>
      @if (docs.cmisEntries.length === 1) {
        <button
          class="btn btn-icon"
          (click)="openDocument(docs.cmisEntries[0])"
          [ngbTooltip]="tooltip"
        >
          <span aria-hidden="true" class="far fa-file-pdf fa-lg align-middle"
                style="text-decoration: none; font-size: 0.9em"></span>
        </button>
      }

      @if (docs.cmisEntries.length > 1) {
        <button
          class="btn btn-icon"
          (click)="openDialog(docs.cmisEntries)"
          [ngbTooltip]="tooltip"
        >
          <span aria-hidden="true" class="far fa-file-pdf fa-lg align-middle"
                style="text-decoration: none; font-size: 0.9em"></span>
        </button>
      }
    </ng-container>
  }
}
